/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import { Fragment, PureComponent } from 'react'

const Color = css`
  width: inherit;
  height: auto;
  path,
  ellipse {
    fill: inherit;
  }
`
export default class SendIco extends PureComponent {
  render() {
    return (
      <Fragment>
        <svg xmlns="http://www.w3.org/2000/svg" width="42.862" height="40.957" viewBox="0 0 42.862 40.957" css={Color}>
          <path
            id="패스_3884"
            data-name="패스 3884"
            d="M-12307.887-17003.381a91.938,91.938,0,0,0,2.9,8.979c.467,1.219,1.187,2.941,4.462,3.541s17.776,3.461,17.776,3.461-16.214,3.422-17.776,3.645-3.839.748-4.462,2.912-2.788,10.7-3.378,11.959-.076,3.521,3.378,2.059,36.917-17.584,38.164-18.271,1.945-2.678-.692-4.125-35.129-16.494-36.752-17.59S-12308.922-17007.359-12307.887-17003.381Z"
            transform="translate(12308.576 17007.307)"
            fill="#ddd"
          />
        </svg>
      </Fragment>
    )
  }
}
